import WelcomeSection001Image from './welcome-section-001.webp'
import WelcomeSection002Image from './welcome-section-002.webp'
import WelcomeSection003Image from './welcome-section-003.webp'
import WelcomeSection004Image from './welcome-section-004.webp'

export {
  WelcomeSection001Image,
  WelcomeSection002Image,
  WelcomeSection003Image,
  WelcomeSection004Image,
}
